module.exports = __webpack_public_path__ + "img/Mask Group 29.3b4cfafe.svg";